export enum BlastPlanTypeEnum {
	Monthly = 'monthly',
	Addon = 'addon',
}

export enum SystemBlastPlansEnum {
	Starter = '6c25f85d-445c-408c-99b6-b0ba99271260',
	Addon = '2f40f854-8607-48db-b96f-e33552aba2b5',
	Pro = 'e5f7a801-d28e-4e3f-81d8-532dae186855',
}
